import { PDFViewer, StyleSheet } from '@react-pdf/renderer';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Offcanvas } from 'react-bootstrap';
import { BookingPerformerModel } from '../../../models';
import { api } from '../../../store/api';
import PerformerContractDocument, { PerformerContractProps } from './PerformerContractDocument';
import { useEffect, useState } from 'react';

const styles = StyleSheet.create({
    viewer: {
        width: window.innerWidth * 0.7,
        height: window.innerHeight - 85,
    },
});

interface LocalProps {
    show: boolean;
    bookingId: number;
    bookingPerformer: BookingPerformerModel;
    onHide: () => void;
}

const PerformerContractOffCanvas = ({ show, bookingId, bookingPerformer, onHide }: LocalProps) => {
    const { data: booking } = api.useGetBookingQuery(bookingId ?? skipToken);
    const { data: performer } = api.useGetPerformerQuery(bookingPerformer.actId);
    const { data: performerAuthorizedContact, isLoading: performerContactIsLoading } = api.useGetContactQuery(
        bookingPerformer.authorizedContactId ?? skipToken
    );
    const { data: siteContact } = api.useGetContactQuery(booking?.siteContactId ?? skipToken);
    const [props, setProps] = useState<PerformerContractProps>();

    useEffect(() => {
        if (performer && (performerAuthorizedContact || !performerContactIsLoading) && siteContact) {
            setProps({ bookingPerformer, booking, performer, performerAuthorizedContact, siteContact });
        }
    }, [bookingPerformer, booking, performer, performerAuthorizedContact, performerContactIsLoading, siteContact]);

    return (
        <Offcanvas className="w-75" show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
                {props && (
                    <PDFViewer style={styles.viewer}>
                        <PerformerContractDocument {...props} />
                    </PDFViewer>
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default PerformerContractOffCanvas;
